@if (isEatClubApp) {
    <div class="footer-wrapper" *appFeatureToggle="'desktop'">
        <img id="downloadBanner" imageSrc="/assets/images/eatclub-download-banner.webp" appDeferImageLoad class="footer-bg" />
        <div class="links">
            <div class="container">
                <div class="brand-meta">
                    <div class="column-box">
                        <div class="brand-name">EatClub</div>
                        <p class="brand-description">
                            Getting food delivered at home is always a great idea. But the whole episode of scrolling endlessly,
                            scanning restaurant ratings, hunting for coupon codes...now that’s not fun at all. So, here’s the
                            smarter way out with EatClub!
                        </p>
                        <p class="brand-description">
                            A membership program that takes you straight to a no-nonsense, curated selection of restaurants. Get
                            unlimited savings with 30% OFF every time on all restaurants and NO extra charges on delivery,
                            packaging or surge.
                        </p>
                        <p class="brand-description">One membership, many benefits!</p>
                    </div>
                    <div class="column-box">
                        <h5>COMPANY</h5>
                        <ul>
                            <li><a routerLink="/about">About Us</a></li>
                            <!-- <li><a routerLink="/faq">Faq’s</a> -->
                        </ul>
                    </div>
                    <div class="column-box">
                        <h5>GET HELP</h5>
                        <ul>
                            <li><a routerLink="/contact">Contact us</a></li>
                            <li><a routerLink="/faq">Help & Support</a></li>
                            <li><a routerLink="/delivery_policy">Delivery Policies </a></li>
                            <li><a routerLink="/privacy_policy">Privacy Policies</a></li>
                            <li><a routerLink="/disclaimers">Disclaimers</a></li>
                        </ul>
                    </div>
                    <div class="column-box">
                        <h5>EXPLORE</h5>
                        <ul>
                            <li><a routerLink="/offers">Offers</a></li>
                            <li><a routerLink="/party_order">Bulk Order</a></li>
                        </ul>
                    </div>
                    <div class="creatives"></div>
                </div>
                <div class="copyright" *appFeatureToggle="'desktop'">
                    <div>
                        Copyright {{ staticText.startYear }} - {{ currentYear }}. EatClub Brands Pvt. Ltd. All rights reserved.
                        <span> &nbsp; {{ appVersion }}</span>
                    </div>
                    <div class="social-icons">
                        <a [href]="links?.share.fb.url" target="_blank" rel="noopener noreferrer">
                            <img
                                src="{{ DEPLOY_URL }}/assets/images/new_social_icons/fb.svg"
                                alt="Facebook Social Link"
                                title="Follow us on Facebook" />
                        </a>
                        <a [href]="links?.share.twitter.url" target="_blank" rel="noopener noreferrer">
                            <img
                                src="{{ DEPLOY_URL }}/assets/images/new_social_icons/twitter.svg"
                                alt="Twitter Social Link"
                                title="Follow us on Twitter" />
                        </a>
                        <a [href]="links?.share.insta.url" target="_blank" rel="noopener noreferrer">
                            <img
                                src="{{ DEPLOY_URL }}/assets/images/new_social_icons/instagram.svg"
                                alt="Instagram Social Link"
                                title="Follow us on Instagram" />
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
}

<ng-template #MwebFooter>
    <div class="mweb-container">
        <div class="fixed-width container">
            <div class="left">
                @if (isBox8App) {
                    <div class="footer-text-mweb">
                        <div class="footer-text">You’ll love us even more</div>
                        <div class="footer-text">on the app!</div>
                    </div>
                }
                <div class="offer">
                    <span>{{ staticText.app_offer.discount }}</span
                    ><br />
                    <span style="font-size: 24px">{{ staticText.app_offer.discount_condition }}</span>
                </div>
                <div class="offer-code">
                    <span>Code: </span>
                    <span class="code" (click)="copyCode($event, code)"
                        >{{ code }}
                        <img src="{{ DEPLOY_URL }}/assets/images/copy-icon.svg" class="copy-icon" />
                    </span>
                </div>
                <div class="store-container">
                    <a href="javascript:void(0);" class="store-img" (click)="appStoreEvent(links.store.apple)">
                        <img appDeferImageLoad imageSrc="{{ DEPLOY_URL }}/assets/images/app-store.png" />
                    </a>
                    <a href="javascript:void(0);" class="store-img" (click)="appStoreEvent(links.store.google)">
                        <img style="float: right" appDeferImageLoad imageSrc="{{ DEPLOY_URL }}/assets/images/google-play.png" />
                    </a>
                </div>
            </div>
            @if (isBox8Desktop) {
                <div class="right">
                    <img
                        class="phone-1 phone-img"
                        src="{{ DEPLOY_URL }}/assets/images/missing.png"
                        appDeferImageLoad
                        imageSrc="{{ DEPLOY_URL }}/assets/images/footer-phone-1.png" />
                    <img
                        class="phone-2 phone-img"
                        src="{{ DEPLOY_URL }}/assets/images/missing.png"
                        appDeferImageLoad
                        imageSrc="{{ DEPLOY_URL }}/assets/images/footer-phone-2.png" />
                </div>
            }
        </div>
    </div>
</ng-template>

@if (isBox8Desktop) {
    <ng-container *ngTemplateOutlet="MwebFooter"></ng-container>
}

<!-- footer in floating div for desktop -->
<ng-template #appLinksUI>
    <ng-container>
        <div class="row">
            <div class="col-sm-12 col-md-12">
                <div class="row footer-links-container">
                    <!--mweb footer-->
                    @if (showMWebFooter()) {
                        <ng-container *ngTemplateOutlet="MwebFooter"></ng-container>
                        @if (showSocialLinks()) {
                            <div class="social-wrapper">
                                <div style="padding-bottom: 10px">FOLLOW US ON</div>
                                @for (link of socialLinks; track link) {
                                    <img
                                        class="social-links"
                                        src="{{ DEPLOY_URL }}/assets/images/missing.png"
                                        appDeferImageLoad
                                        [imageSrc]="link.image"
                                        (click)="openSocialLink(link.url)" />
                                }
                            </div>
                        }
                    } @else {
                        <div class="col-sm-9 col-md-9">
                            <div class="footer-text" [ngClass]="isEatClubApp ? 'eatclub-style' : ''">
                                <p class="footer-heading" #footerHeading>Get started with the mobile app!</p>
                                <p class="footer-subheading">
                                    {{ staticText.app_offer.messgeText }}
                                    <br />{{ staticText.app_offer.codeText }}
                                </p>
                            </div>
                            <div class="footer-app-links">
                                <a class="apple-store-link" href="javascript:void(0);" (click)="appStoreEvent(links.store.apple)">
                                    <span class="apple-store-icon"></span>
                                    <span>Download on App Store</span>
                                </a>
                                <a
                                    class="google-store-link"
                                    href="javascript:void(0);"
                                    (click)="appStoreEvent(links.store.google)">
                                    <span class="google-store-icon"></span>
                                    <span>Download on Play Store</span>
                                </a>
                            </div>
                        </div>
                    }

                    <div class="col-sm-3 col-md-3">
                        <div class="app-banner"></div>
                    </div>
                </div>
            </div>
        </div>
    </ng-container>
</ng-template>

<ng-template #footerLinks>
    @if (!isBox8Desktop) {
        <div class="space-50"></div>
    }
    <div class="inner-container">
        <div class="column-box">
            <h5>{{ staticText.brandName }}</h5>
            <ul>
                <li><a routerLink="/about">About us</a></li>
                <li><a routerLink="/faq">Help & Support</a></li>
                <li><a routerLink="/contact">Contact us</a></li>
                <li><a routerLink="/delivery_policy">Delivery Policies </a></li>
                <li><a routerLink="/privacy_policy">Privacy Policies</a></li>
                <li *appFeatureToggle="'hiringLink'">
                    <a href="https://box8.recruitee.com/" target="_blank"> We're Hiring </a>
                </li>
            </ul>
        </div>
        <div class="column-box">
            <h5>Explore</h5>
            <ul>
                <li><a routerLink="/offers">Offers</a></li>
                <li *appFeatureToggle="'blogLink'"><a [href]="links?.blog" target="_blank">Blog</a></li>
                <li><a routerLink="/disclaimers">Disclaimers</a></li>
                <li>
                    <a routerLink="/refer">{{ staticText.share.link_text }}</a>
                </li>
            </ul>
        </div>
        <div class="column-box">
            <h5>Follow</h5>
            <div class="head-social">
                <a [href]="links?.share.fb.url" title="Follow on Facebook" class="head-facebook" target="_blank"></a><br />
                <a [href]="links?.share.twitter.url" title="Follow on Twitter" class="head-twitter" target="_blank"></a>
            </div>
        </div>
    </div>
    <div class="clearfix"></div>
    <div class="space-20"></div>
</ng-template>

<footer #footerRef>
    @if (showAppDownloadOptions) {
        @if (eatClubMobileShowFooterLinks && !isBox8Desktop) {
            <section *appFeatureToggle="'appLinks'">
                <div class="container-fluid footer-links-wrapper footer-container-A" [ngClass]="{ 'color-bg': isBox8App }">
                    <ng-container *ngTemplateOutlet="appLinksUI"></ng-container>
                </div>
            </section>
        }
    }

    @if (!isEatClubApp) {
        <div class="row-fluid footer-black" *appFeatureToggle="'desktop'">
            <div class="space-140" *appFeatureToggle="'appLinks'">
                @if (isBox8Desktop) {
                    <div class="brand-features">
                        @for (feature of brandFeatures; track feature) {
                            <div class="feature-container">
                                <img [src]="feature.image" class="feature-icon" />
                                <div class="details">
                                    <div class="heading">{{ feature.heading }}</div>
                                    <div>{{ feature.subheading }}</div>
                                </div>
                            </div>
                        }
                    </div>
                }
            </div>
            <ng-container *ngTemplateOutlet="footerLinks"></ng-container>
        </div>
        <div class="footer-bottom" *appFeatureToggle="'desktop'">
            <div class="container-fluid">
                <div class="col-sm-12 text-center">
                    Copyright {{ staticText.startYear }} - {{ currentYear }}. EatClub Brands Pvt. Ltd. All rights reserved.
                    <span> &nbsp; {{ appVersion }}</span>
                </div>
            </div>
        </div>
    }
</footer>
